<template>
  <div id="delivery" style="box-shadow: rgba(0, 0, 0, 0.3) 0px 20px 22px 0px;">
    <div >
      <div class="xs-flex text-glitch-fix" v-if="!hasDisposition">
        <div data-item-id="localisation-delivery" data-item-type="tool" data-item-position="1" data-synth="form-delivery" data-type="DELIVERY"
             class="order-type-button xs-flex-center xs-flex-auto xs-min-width-0 xs-p-10 bold rounded-top no-outline xs-nowrap text-glitch-fix "
             v-bind:class="isDelivery" role="button" style="margin-right: 2px; font-size: 16px;" tabindex="0"
             v-on:click="clickActiveDelivery">
          <i class="icon-delivery xs-mr-5 xs-hide md-block"></i><span>{{$t('delivery')}}</span>
        </div>
        <div data-item-id="localisation-takeaway" v-if="!isLanding" data-item-type="tool" data-item-position="2" data-synth="form-collection" data-type="CARRYOUT"
             class="order-type-button xs-flex-center xs-flex-auto xs-min-width-0 xs-p-10 bold rounded-top no-outline xs-nowrap text-glitch-fix"
             v-bind:class="isCollection" role="button" style="font-size: 16px;" tabindex="0"
             v-on:click="clickActiveCollection">
          <i class="icon-collection xs-mr-5 xs-hide md-block"></i><span v-html="$t('collection')" class="text-center"></span>
        </div>
      </div>
      <div class="localisation xs-fill-white xs-p-15 rounded-bottom" v-if="!hasDisposition">
        <div v-if="orderType == $const.CARRYOUT">
<!--          <p> <span class="fw600">{{$t('localization.search_by_address_zipcode')}}</span></p>-->
        </div>
        <div v-else>
          <div v-if="$auth.check()">
            <div v-show="customer.list_address.length > 0">
              <div class="xs-text-center heading-hr t16 xs-p-10  " style="padding-bottom: 5px !important;">
                {{$t('home.saved_address')}}
              </div>
              <div class="">
                <v-select :multiple="false" :options="customer.list_address" class="select-localization"
                          @input="setSelectedAddress"></v-select>
              </div>
            </div>
          </div>
<!--          <p> <span class="fw600">{{$t('localization.search_by_address')}}</span></p>-->
        </div>
        <div v-if="warningDisposition" class="xs-pb-15 xs-fill-yellow xs-text-black xs-p-10 xs-mb-10 arrow-bottom-yellow typo-l6b warning-disposition" style="display: block;">
          <span v-if="orderType == $const.CARRYOUT" class="carryout">{{$t('localization.popup_carryout')}}</span>
          <span v-else class="delivery" >{{$t('localization.popup_delivery')}}</span>
        </div>
        <div class="xs-flex xs-items-end xs-border xs-border-gray-light xs-border-1 rounded xs-relative xs-z-300 xs-fill-white xs-mb-10 xs-items-center mt-10">
          <div class="xs-flex-1">

            <input v-if="orderType == $const.CARRYOUT" class="search search--hut input xs-border-none xs-py-10 xs-px-10" id="address-autocomplete"
                   data-synth="address-input" name="address" autocomplete="off" autocorrect="off" autocapitalize="off"
                   v-bind:placeholder="$t('localization.placehover_search_by_address_carryout')"
                   spellcheck="false" value="" type="text"  v-model="searchAutoComplete">

            <input v-else class="search search--hut input xs-border-none xs-py-10 xs-px-10" id="address-autocomplete"
                   data-synth="address-input" name="address" autocomplete="off" autocorrect="off" autocapitalize="off"
                   spellcheck="false" v-bind:placeholder="$t('localization.placehover_search_by_address')" value="" type="text"  v-model="searchAutoComplete">
          </div>
          <a href="javascript: void(0)" v-if="searchAutoComplete.length > 0 && !loadingFreeText">
            <button class="flex-1 t13 min-height-59 pl-10 pr-10" @click="clearText">
              <img src="../../assets/images/icons/delete.png"/>
            </button>
          </a>
          <div>
            <a href="javascript: void(0)" class="buttonload flex-1 min-height-59" v-if="loadingZip"
               style="border-radius: 3px;line-height: 4">
              <i class="fa fa-refresh fa-spin"></i>{{$t('button_loading')}}
            </a>
            <a href="javascript: void(0)" data-item-id="localisation-submit" data-item-type="tool"
               data-item-position="3" class="button button--primary flex-1  min-height-59"
               style="border-radius: 3px;line-height: 4" v-else @click="searchDelivery">
              <div class="flex w-full flex-col  t14">{{$t('button_search')}}</div>
            </a>
          </div>
          <div>
            <button class="buttonload button button--primary flex-1 t13" v-if="loadingFreeText">
              <i class="fa fa-refresh fa-spin" style="height: 14px;width: 14px;background-size: 14px;"></i>{{$t('button_loading')}}
            </button>
          </div>
        </div>
        <div v-if="messagePopup.length > 0" class="pt-10">
          <p class="pl-10 pr-10 flex1 display-flex items-center">
            <span class="xs-text-red" >{{messagePopup}}</span>
          </p>
        </div>
        <div class="clearfix"></div>
        <div class="contain-outlet" v-if="mode=='free'">
          <ul class="list-outlets" v-if="addressList.length > 0">
            <li v-for="(outlet,index) in addressList" :key="index" class="outlet-item inactive text-black" @click="clickChosenAddress(outlet)">
              <h4><span class="text-capitalize"><i class="fa fa-map-marker "  ></i> {{outlet.address}}</span></h4>
            </li>
          </ul>
        </div>
        <div class="clearfix"></div>
        <div>
            <div class="outlet-item inactive text-black" v-show="orderType != $const.CARRYOUT">
              <button class="trigger-location use-current-location flex xs-items-center"
                      @click="openmap()"
                      style="color: #4a90e2">
                <i class="fa fa-map-marker mr-10"></i>{{$t('localization.or_use_my_current_location')}}
              </button>
              <div v-show="showMapDelivery" style="margin-top: 10px">
                <div style="margin-bottom: 10px">
                <p id="mylocation" class="alert alert-info col-sm-6 mb-0">{{searchAutoComplete}}</p>
                <div class="button-order-datetime  col-sm-6 pb5 pt5 pl-0 pr-0" style="display: block; margin-bottom: 10px;">
                  <div class="xs-flex xs-items-end">
                    <button class="button button--primary xs-flex-1 save-disposition " @click="orderNow" data-synth="button--delivery" type="button">
                      <div class="xs-flex xs-full-width xs-flex-column xs-py-10">
                        <span class="bold">{{$t('order_now')}}</span>
                      </div>
                    </button>
                  </div>

                </div>
                </div>
                <div id="map_delivery" style="height: 500px; width: 100%"></div>
              </div>
            </div>

            <button  data-item-id="localisation-auto" data-item-type="tool" data-item-position="4"
            v-if="searchAutoComplete.length <= 0 && orderType == $const.CARRYOUT"
            class="trigger-location use-current-location flex xs-items-center pull-left" v-on:click="useMyLocation"
            style="color: #4a90e2"><i class="icon-geo mr-10"></i> {{$t('using_my_local_carryout')}}</button>

            <a href="javascript:void(0)" class="cursor-pointer cl-78838c border-b t13 pull-right decoration-none"
            v-if="outletList.length > 1" v-on:click="showHideMap(mapOpen)">{{ $t('button_open_maps')}}</a>
          </div>
          <div class="clearfix"></div>
          <div class="contain-outlet">
            <ul class="list-outlets" v-if="outletList.length > 0 && orderType == $const.CARRYOUT">
              <li v-for="(outlet,index) in outletList" :key="index" class="outlet-item inactive text-black"
              v-bind:class="{highlight: index == highlight}" @click="beforeClickChosenOutlet(outlet)">
                <h4> {{index +1}}. <span class="text-capitalize">{{outlet.name}} <span class="t12"> ( {{formatNum(outlet.distance)}} km )</span></span></h4>
                <p>{{outlet.address}}</p>
              </li>
            </ul>
          </div>
        <div class="clearfix"></div>
        <div v-if="outletList.length <= 0  && addressList.length <= 0 && message.length >0" class="pt-10">
          <hr class="m-5">
          <p class="flex1 display-flex items-center">
            <img src="https://static.phdvasia.com/jp/icons/error.svg" width="20" class= "" style="height:20px;flex: 0 0 30px;">
            <span  style="">{{message}}</span>
          </p>
        </div>
        <div class="clearfix"></div>
      </div>

      <div class="xs-p-20 localisation xs-fill-fcfcfc rounded-bottom xs-fill-white text-center"
           v-if="hasDisposition">
        <div class="xs-mb-20">
          <div v-if="$i18n.locale == $const.LANG_JP">
            <p>
              <b class="border-b">
                {{getDeliveryInfo(this).addressInfo}}
              </b>
              <span class="t14">{{$disposition.getByKey(this, 'orderType', '') == $const.DELIVERY ? $t('delivery_to') : $t('take_away')}}</span>
            </p>
          </div>
          <div v-else>
            <p>
              <span class="t14">{{$disposition.getByKey(this, 'orderType', '') == $const.DELIVERY ? $t('delivery_to') : $t('take_away')}}</span>
              <strong class="border-b uppercase">
              {{getDeliveryInfo(this).addressInfo}}
              </strong>
            </p>
          </div>

          <button class="btn btn-default w-full bg t16" style="min-height: 42px; background-color: #cccccc45"
                  @click="resetDisposition"> {{$t('button_change')}}
          </button>
        </div>

        <div class="">
          <button v-on:click="viewMenu" class="btn btn-success w-full font-bold t16" style="min-height: 42px">
            {{$t('home.button_view_all_pizza')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ConfirmStoreClose from '../popup/ConfirmStoreClose.vue'
  import ModalDelivery from '../popup/ModalDelivery.vue'
  import ModalConfirm from '../popup/ModalConfirm.vue'
  import ModalCarryout from '../popup/ModalCarryout.vue'
  import ModalWarning from '../popup/ModalWarning.vue'
  import ModalActionError from '../popup/ModalActionError.vue'
  import ModalMap from '../popup/ModalMaps.vue'
  import ModalMapDelivery from '../popup/ModalMapDelivery'
  import MaskedInput from 'vue-masked-input'
  import vSelect from 'vue-select'
  import ASAPPopup from '../popup/OrderASAP.vue'
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import * as action from '../../store/actions'

  let active = 'xs-fill-white xs-text-red xs-relative xs-z-200 xs-py-15'
  let inactive = 'xs-fill-gray-lightest xs-text-gray-medium xs-grayscale'

  var keApi = ''
  var region = ''
  var language = ''
  export default {
    name: 'localization',
    props: {
      isLanding: false,
      routeLanding: false
    },
    beforeDestroy () {
      this.$root.$off('onCheckValidOutlet')
      this.$root.$off('onChangeOutlet')
      this.$root.$off('onclickChosenOutlet')
      this.$root.$off('activeCollectionMap')
      this.$root.$off('search')
      this.$root.$off('activeTabLocalization')
    },
    mounted () {
      keApi = this.$session.get('google-key-api')
      region = this.$const.COUNTRY_CODE
      language = this.$const.DEFAULT_LANGUAGE
      var vm = this
      window.infowindowClick = function (index) {
        vm.infowindowClick(index)
      }

      this.$root.$on('onCheckValidOutlet', (data) => {
        vm.checkValidOutlet()
      })
      this.$root.$on('search', (data) => {
        vm.keepCurrentLocation = true
        vm.searchAutoComplete = data.address
        vm.lat = data.lat
        vm.lng = data.lng
        vm.handleCallbackMapDelivery(data.lat, data.lng)
      })
      this.$disposition.init(this)
      this.$root.$on('onChangeOutlet', (index) => {
        vm.onChangeOutlet(index)
      })
      this.$root.$on('onclickChosenOutlet', (outlet) => {
        if(this.$cart.order_type == "D"){
            this.orderType = this.$const.DELIVERY
        }else{

            this.orderType = this.$const.CARRYOUT
        }
        vm.clickChosenOutlet(outlet)
      })
      this.$root.$on('activeCollectionMap', () => {
        this.searchAutoComplete = this.addressSelected ? this.addressSelected : this.searchAutoComplete
        this.clickActiveCollection(this.searchAutoComplete.length > 0)
        this.searchLocation = true
        this.getLatLog()
      })

      if (this.$auth.check()) {
        this.initCustomerList()
      }

      this.$root.$on('clearAndCreateNewStore', (outlet) => {
        let vm = this
        vm.$cart.removeCart(vm)
        vm.clickChosenOutlet(outlet)
      })

      this.tracklocalization()
      this.loadScriptMap()
      this.initGeocoder()
      this.initAutoCompleteSearch()
      if (vm.$root.$route.query.orderTypeDefault && vm.$root.$route.query.orderTypeDefault === 'collection') {
        this.clickActiveCollection()
      }else {
        this.clickActiveDelivery()
      }
      if (this.$route.query.store_code) {
        this.localisationDirectlyTakeaway(this.$route.query.store_code)
      }
      this.$root.$on('activeTabLocalization', (type) => {
        if (type === vm.$const.DELIVERY) {
          vm.clickActiveDelivery()
        } else if (type === vm.$const.CARRYOUT) {
          vm.clickActiveCollection()
        }
      })
    },
    computed: {
        ...mapGetters({
            warningDisposition: 'warningDisposition',
        })
    },
    watch: {
      searchZipCode: function (newValue, oldValue) {
        if (!newValue) {
          this.searchByZipCode()
        }
      },
      searchAutoComplete: function (newValue, oldValue) {
        if (!this.keepCurrentLocation) {
          this.lat = ''
          this.lng = ''
        }
        this.keepCurrentLocation = false
        if (newValue) {
          this.messagePopup = ''
        }
        if (!this.searchLocation) {
          this.initAutoCompleteSearch()
        }
      }
    },
    data () {
      return {
        keepCurrentLocation: false,
        deliveryInfo: {
          location: '',
          city: '',
          state: '',
          streetName: '',
          streetNumber: '',
          postalCode: '',
        },
        customer: {
          list_address: [],
          list_store: []
        },
        print_model: false,
        errorPostalCode: '',
        highlight: null,
        locationCenter: {lat: 0, lng: 0},
        searchLocation: false,
        isDelivery: active,
        isCollection: inactive,
        orderType: this.$const.DELIVERY,
        isShow: this.checkPosition(this),
        searchAutoComplete: '',
        searchZipCode: '',
        outletList: [],
        addressList: [],
        mode: '',
        loadingFreeText: false,
        loadingZip: false,
        result: {},
        message: '',
        geocoder: {},
        map: {},
        marker: {},
        markers: [],
        addressAutoComplete: false,
        addressSelected: '',
        mapOpen: false,
        hasDisposition: this.checkPosition(this),
        showMapDelivery: false,
        lat: 0,
        lng: 0,
        current_location: false,
        addressDelivery: '',
        messagePopup: ''
      }
    },
    methods: {
      ...mapActions({
        setDisposition: action.SET_DISPOSITION,
        setWarningDisposition: action.SET_WARNING_DISPOSITION,
        setShowModalTakeAwayLess: action.SET_SHOW_MODAL_TAKE_AWAY_LESS
      }),
      localisationDirectlyTakeaway (code) {
        var vm = this
        vm.callEventBus(vm.$const.EVENT_BUS.LOADING, true)
        this.axios.apiOutlet.getOutLetByCode({code: code}, function (response) {
          vm.$session.remove('cart')
          vm.$session.remove('disposition')
          vm.$root.$emit('cartUpdate')
          vm.hasDisposition = false
          vm.result = {}
          let outletInfo = response.data.data.item
          vm.result.takeaWayLess = 1
          vm.result.outletId = outletInfo.id
          vm.result.orderType = vm.$const.CARRYOUT
          vm.orderType = vm.$const.CARRYOUT
          vm.result.lat = outletInfo.lat
          vm.result.long = outletInfo.long
          vm.result.outletAddress = outletInfo.address
          vm.result.outletName = outletInfo.name
          vm.result.outletCode = outletInfo.code
          vm.result.tier = outletInfo.tier
          vm.checkValidOutlet()
          vm.callEventBus(vm.$const.EVENT_BUS.LOADING, false)
        },function (error) {
          vm.callEventBus(vm.$const.EVENT_BUS.LOADING, false)
        })
      },
      viewMenu() {
        this.$store.commit('setCategoryUuid', null)
        if (this.routeLanding) {
          this.redirectToMenuPage('promos', 'cheesybites')
        } else {
          this.redirectToMenuPage()
        }
      },
      initCustomerList () {
        var vm = this
        this.axios.apiCustomer.getProfile((response) => {
          let data = []
          for (let i in response.data.data.item.locations) {
            data.push({
              label:  response.data.data.item.locations[i].house_no + ' ' + response.data.data.item.locations[i].location,
              code: response.data.data.item.locations[i]

            })
          }
          let dataStore = []
          for (let j in response.data.data.item.outlets) {
            dataStore.push({
              label: response.data.data.item.outlets[j].outlet_name,
              code: response.data.data.item.outlets[j]

            })
          }
          vm.customer.list_address = data
          vm.customer.list_store = dataStore
        })
      },
      searchDelivery (){
        let vm = this
        if(this.orderType == this.$const.CARRYOUT){
          this.clickActiveCollection()
        }else{
          if(vm.isMobile()) {
            let geocoder = new google.maps.Geocoder()
            geocoder.geocode({'address': vm.searchAutoComplete}, function (results, status) {
              if (status === 'OK') {
                vm.$modal.show(ModalMapDelivery, {lat: results[0].geometry.location.lat(), lng:results[0].geometry.location.lng(), address: vm.searchAutoComplete})
              }
            })
          }else{
            vm.getLagLngByAddress()
          }
        }
      },
      setSelectedAddress(value) {
        if (!value) {
          return
        }

        this.lat = value.code.lat
        this.lng = value.code.long
        this.keepCurrentLocation = true
        this.searchAutoComplete = value.label
        this.addressAutoComplete = ''

        this.deliveryInfo = {
          city: value.code.city,
          streetNumber: value.code.house_no,
          streetName: value.code.street_name,
          state: value.code.state,
          postalCode: value.code.zip_code
        }

        this.getNewLagLngByAddress()
      },
      getNewLagLngByAddress () {
        let vm = this
        let geocoder = new google.maps.Geocoder()
        geocoder.geocode({'address': vm.searchAutoComplete}, function (results, status) {
          vm.lat = results[0].geometry.location.lat()
          vm.lng = results[0].geometry.location.lng()
          vm.searchOutletByLatLng()
        })
      },
      openmapHaveAddress (lat, lng) {
          let vm = this
          var location = {lat: lat, lng: lng}
          vm.showMapDelivery = vm.showMapDelivery ? vm.showMapDelivery : !vm.showMapDelivery
          var map = new google.maps.Map(
              document.getElementById('map_delivery'), {
                  zoom: 15,
                  center: location,
                  streetViewControl: false,
                  fullscreenControl: false
              });

          var marker = new google.maps.Marker({
              position: location,
              map: map,
              draggable: true,
              animation: google.maps.Animation.DROP,
          });
          marker.addListener('drag', (event) => {
              vm.getAddress(event.latLng.lat(),event.latLng.lng())
          });
      },
      /**
       * user my current location for delivery
       * **/
      openmap (lat = "", lng = "") {
          var vm = this
          vm.current_location = !!lat
          navigator.geolocation.getCurrentPosition(function (position) {
              lat = lat || position.coords.latitude
              lng = lng || position.coords.longitude
              vm.lat = lat
              vm.lng = lng
              var location = {lat: lat, lng: lng}

            if(vm.isMobile()) {
              vm.$bus.$emit('loading', 'none')
              vm.$modal.show(ModalMapDelivery, {lat: lat, lng: lng, address: '' })
              // vm.showHideMap(false)
            }else{
              vm.showMapDelivery = vm.showMapDelivery ? vm.showMapDelivery : !vm.showMapDelivery
              var map = new google.maps.Map(
                document.getElementById('map_delivery'), {
                  zoom: 15,
                  center: location,
                  streetViewControl: false,
                  fullscreenControl: false,
                });
              var marker = new google.maps.Marker({
                position: location,
                map: map,
                draggable: true
              });
              vm.getAddress(lat, lng)
              marker.addListener('drag', (event) => {
                vm.getAddress(event.latLng.lat(), event.latLng.lng())
              });
            }
          },
            function (error) {
              if (error.code == error.PERMISSION_DENIED) {
                vm.messagePopup = vm.$t('message_geolocation_denied_1')
              }
            });
      },
      searchOutletByLatLng () {
        var vm = this
        var lat = vm.lat
        var lng = vm.lng
        if (!lng || !lat) {
              vm.$modal.show(ModalDelivery, {
                message: '',
                methodSearch: vm.$const.DEFAULT_CONFIG_APP,
                hideCollectionButton: true,
                chooseAnotherDelivery: function () {
                  vm.openmapHaveAddress(lat || this.$const.GEO.POSITION.LAT, lng || this.$const.GEO.POSITION.LNG);
                }
              })
              return false
          }
          let val = lng + ',' + lat
          let data = {location: val, disposition: 'D', limit: 10}
          vm.message = ''
          vm.axios.apiOutlet.checkLocation(data, function (response) {
              vm.searchLocation = false
              vm.outletList = response.data.data.items
              let hideCollectionButton = false
              if (vm.isLanding) {
                hideCollectionButton = true
              }
              if (vm.outletList.length <= 0) {
                vm.evenTrackingNotInDeliveryZone(vm.searchAutoComplete, lat, lng)
                  vm.$modal.show(ModalDelivery, {
                    message: '',
                    methodSearch: vm.$const.DEFAULT_CONFIG_APP,
                    hideCollectionButton: hideCollectionButton,
                    chooseAnotherDelivery: function () {
                      vm.openmapHaveAddress(lat, lng);
                    }
                  })
              } else {
                if(vm.orderType == vm.$const.DELIVERY)
                {
                  vm.result.outletAddress = vm.outletList[0].address
                  vm.result.orderType = vm.orderType
                  vm.result.locationName = vm.outletList[0].address
                  vm.result.cityName = vm.outletList[0].city_name
                  vm.result.villeageName = vm.outletList[0].villeage_name
                  vm.result.st = vm.outletList[0].st
                  vm.result.outletId = vm.outletList[0].id
                  vm.lat = lat
                  vm.lng = lng
                  vm.checkValidOutlet()
                }
              }
          }, function (error) {
              console.log(`error: ${error}`)
            vm.evenTrackingNotInDeliveryZone(vm.searchAutoComplete, lat, lng)
              vm.$modal.show(ModalDelivery, {
                message: '',
                methodSearch: vm.$const.DEFAULT_CONFIG_APP,
                hideCollectionButton: true,
                chooseAnotherDelivery: function () {
                  vm.openmapHaveAddress(lat, lng);
                }
              })
          })
      },
      handleCallbackMapDelivery(lat, lng, triggerOrderNow = true) {
        let vm = this
        var geocoder = new google.maps.Geocoder;
        let latlng = {lat: lat, lng: lng}
        geocoder.geocode({'location': latlng}, function (results, status) {
          if (status === 'OK') {
            if (results && results[0]) {
              vm.lat = lat;
              vm.lng = lng;
              vm.setDeliveryInfo(results[0]);
            }
          }
          if (triggerOrderNow) {
            vm.orderNow();
          }
        });
      },
      orderNow () {
          this.$cart.order_type = 'D'
          if( !this.current_location) {
              this.searchOutletByLatLng()
          }else{
              this.checkValidOutlet()
          }
      },
      getAddress (lat, lng) {
          let vm = this
          vm.lat = lat
          vm.lng = lng
          var geocoder = new google.maps.Geocoder;
          let latlng = {lat: lat * 1, lng: lng * 1}
          geocoder.geocode({'location': latlng}, function (results, status) {
              if (status === 'OK') {
                  if (results && results[0]) {
                      vm.setDeliveryInfo(results[0])
                      vm.keepCurrentLocation = true
                      vm.searchAutoComplete = results[0].formatted_address
                  }
              }
          });
      },
      setDeliveryInfo (data) {
        let vm = this;
        var componentForm = {
          street_number: 'short_name',
          route: 'long_name',
          sublocality_level_1: 'long_name',
          locality: 'long_name', // city
          administrative_area_level_1: 'short_name', // state
          country: 'long_name',
          postal_code: 'short_name'
        };
        let subLocal = '';
        if (data && data.hasOwnProperty('address_components')) {
          for (var i = 0; i < data.address_components.length; i++) {
            var addressType = data.address_components[i].types[0];
            if (componentForm[addressType]) {
              componentForm[addressType] = data.address_components[i][componentForm[addressType]];
            } else if (addressType == 'political' && data.address_components[i].types.length >= 3 && data.address_components[i].types[2] == 'sublocality_level_1') {
              subLocal = data.address_components[i].long_name;
            }
          }
        }
        if (componentForm.route !== 'long_name' && subLocal.length > 0) {
          componentForm.route += ', ' + subLocal;
        }

        let sublocality = componentForm.sublocality_level_1 !== 'long_name' ? ', ' + componentForm.sublocality_level_1 : ''
        vm.deliveryInfo = {
          city: componentForm.locality !== 'long_name' ? componentForm.locality : '',
          streetNumber: componentForm.street_number !== 'short_name' ? componentForm.street_number : '',
          streetName: componentForm.route !== 'long_name' ? componentForm.route + sublocality : '',
          state: componentForm.administrative_area_level_1 !== 'short_name' ? componentForm.administrative_area_level_1 : '',
          postalCode: componentForm.postal_code !== 'short_name' ? componentForm.postal_code : ''
        }
      },
      clearText () {
          this.searchAutoComplete = ''
          this.clearOutlet()
      },
      clearOutlet () {
          this.outletList = []
          this.addressList = []
      },

      tracklocalization () {
        let layer = {
          'assets': {
            'tools': [
              {
                'id': 'localisation-delivery',
                'type': 'storefinder',
                'name': 'delivery-tab',
                'attributes': {
                  'function': 'show-delivery-tab'
                }
              },
              {
                'id': 'localisation-takeaway',
                'type': 'storefinder',
                'name': 'takeaway-tab',
                'attributes': {
                  'function': 'show-takeaway-tab'
                }
              },
              {
                'id': 'localisation-auto',
                'type': 'storefinder',
                'name': 'auto-locate-button',
                'attributes': {
                  'function': 'auto-locate-user'
                }
              }
            ]
          }
        }
        this.eventTrackingModule(layer)
      },
      resetDisposition () {
        var vm = this
        var lastOrderType = this.$disposition.getByKey(this, 'orderType', '')
        vm.setWarningDisposition(false)
        vm.$modal.show('dialog', {
          text: vm.$t('confirm_change_disposition'),
          buttons: [
            {
              title: vm.$t('button_yes'),
              handler: () => {
                vm.$modal.hide('dialog')
                this.$session.remove('cart')
                this.$session.remove('disposition')
                vm.setDisposition({})
                vm.addCustomEvent('ABANDON_CART', 'ABANDON CART')
                this.$root.$emit('cartUpdate')
                this.hasDisposition = false
                if (lastOrderType == this.$const.CARRYOUT) {
                  this.clickActiveCollection()
                }
                vm.$root.$emit('closePopUpClosing')
                vm.$root.$emit('updateHasDisposition',false)
              }
            },
            {
              title: vm.$t('button_close')
            }
          ]
        })
      },
      showHideMap (flag) {
        this.mapOpen = !flag
        if (this.mapOpen) {
          this.$modal.show(ModalMap, {outletList: this.outletList}, {height: 'auto'}, {
            'opened': this.beforeOpen,
            'before-close': this.beforeClose
          })
        } else {
          this.$root.$emit('onCloseMap')
        }
      },
      /**
       *  Intit google map
       * */
      initMap () {
        this.map = new google.maps.Map(document.getElementById('mapLocalization'), {
          center: {lat: this.$const.GEO.POSITION.LAT, lng: this.$const.GEO.POSITION.LNG},
          zoom: 15,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          mapTypeControl: false
        })
      },
      initAutoCompleteSearch () {
        var vm = this

        let element = document.getElementById('address-autocomplete')
        if (typeof google !== 'undefined' && typeof(element) !== 'undefined' && element != null && !this.addressAutoComplete) {
          this.addressAutoComplete = new google.maps.places.Autocomplete(
            (document.getElementById('address-autocomplete')),
            {componentRestrictions: {country: this.$const.COUNTRY_CODE},fields: ['place_id', 'geometry', 'address_components']}
          )
          this.addressAutoComplete.setFields(['place_id', 'geometry', 'address_components'])
          this.addressAutoComplete.addListener('place_changed', () => {
            let place = this.addressAutoComplete.getPlace()
            vm.searchAutoComplete = document.getElementById('address-autocomplete').value
            if (!place) {
              return
            }
            let lat = place.geometry.location.lat()
            let lng = place.geometry.location.lng()
            vm.lat = lat
            vm.lng = lng
            vm.deliveryInfo = {
                city: '',
                state: '',
                streetNumber: '',
                streetName: '',
                postalCode: ''
            }
            if (vm.orderType == vm.$const.CARRYOUT) {
              vm.clickActiveCollection()
            } else {
              vm.setDeliveryInfo(place)
              vm.searchOutletByLatLng()
            }
          })
        }else{
          vm.outletList = []
        }
      },
      /**
       * Click on Delivery tab
       * */
      clickActiveDelivery () {
        this.addressAutoComplete = false
        this.orderType = this.$const.DELIVERY
        this.isDelivery = active
        this.isCollection = inactive
        this.message = ''
        this.addressList = []
        this.outletList = []
        this.searchAutoComplete = ''
        if(this.showMapDelivery) {
          this.searchAutoComplete = this.addressDelivery
          this.openmapHaveAddress(this.lat,this.lng)
        }
        this.$session.set('orderType', this.$const.DELIVERY)
      },
      /**
       * Click on Collection tab
       * */
      clickActiveCollection (ignore = false) {
        this.addressDelivery = this.searchAutoComplete
        this.orderType = this.$const.CARRYOUT
        this.isDelivery = inactive
        this.isCollection = active
        this.message = ''
        this.addressList = []
        this.outletList = []
          if(this.searchAutoComplete && !ignore) {
            this.getLatLog ()
          }
        this.$session.set('orderType', this.$const.CARRYOUT)
      },
      infowindowClick (index) {
        let outlet = this.outletList[index]
        this.clickChosenOutlet(outlet)
      },
      onChangeOutlet (index) {
        let flag = false
        if (this.locationCenter.lat != 0 && this.locationCenter.lng != 0) {
          flag = true
          index += 1
        }
        for (let i in this.markers) {
          if (i == 0 && flag) continue
          let url = this.markers[i].originIcon
          if (i == index) {
            url = this.markers[i].hoverIcon
          }
          this.markers[i].setIcon({
            url: url,
            scaledSize: new google.maps.Size(40, 40)
          })
        }
        if (this.markers.length > 0) {
          this.map.panTo(this.markers[index].position)
        }
      },
      /**
       * Using your location for show google map
       * */
      useMyLocation () {
        var vm = this
        vm.searchLocation = true
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (position) {
            vm.getAddressByLatLog({lat: parseFloat(position.coords.latitude), lng: parseFloat(position.coords.longitude)})
            vm.searchByLocation(position.coords.latitude, position.coords.longitude)
            vm.locationCenter.lat = position.coords.latitude
            vm.locationCenter.lng = position.coords.longitude
          },
            function (error) {
              if (error.code == error.PERMISSION_DENIED) {
                vm.messagePopup = vm.$t('message_geolocation_denied_1')
              }
            })
        }
      },
      initGeocoder () {
        if (typeof google !== 'undefined') {
          this.geocoder = new google.maps.Geocoder()
        }
      },
      /**
       * Get lat long from address
       * */
      getAddressByLatLog (latLong) {
        var vm = this
        vm.locationCenter.lat = latLong.lat
        vm.locationCenter.lng = latLong.lng
        this.initGeocoder()
        vm.searchLocation = true
        this.geocoder.geocode({'location': latLong}, function (results, status) {
          if (status === 'OK') {
            if (results[0]) {
              vm.searchAutoComplete = results[0].formatted_address
            }
          }
        })
      },
      /**
       * Get lat long from address
       * */
      getLatLog () {
        var vm = this
        let geocoder = new google.maps.Geocoder()
        geocoder.geocode({'address': this.searchAutoComplete}, function (results, status) {
          if (status === 'OK') {
            let lat = results[0].geometry.location.lat()
            let lng = results[0].geometry.location.lng()

            vm.searchByLocation(lat, lng)
          }
        })
      },

      /**
       * show message to confirm
       */
      beforeClickChosenOutlet (outlet) {
        let vm = this
        if(vm.$cart.getDetail(vm)) {
          vm.$modal.show(ModalConfirm,{outlet: outlet})
        }else{
            this.$cart.order_type = 'C'
          vm.clickChosenOutlet(outlet)
        }
      },
      /**
       * Chosen a address
       * */
      clickChosenOutlet (outlet) {
        this.result = {}
        if (outlet) {
          // repair data for store
          this.result.lat = outlet.lat
          this.result.long = outlet.long
          this.result.outletAddress = outlet.address
          this.result.orderType = this.orderType
          this.result.outletId = outlet.id
          this.result.outletName = outlet.name
          this.result.outletCode = outlet.code
          this.result.tier = outlet.tier
          if (this.orderType == this.$const.DELIVERY) {
            this.clickChosenAddress(outlet)
          }else{
            this.checkValidOutlet()
          }
        }
      },
      /**
       * Chosen a address
       *
       * */
      clickChosenAddress (outlet) {
        this.result = {}
        if (outlet) {
          if (this.orderType == this.$const.DELIVERY) {
            this.addressSelected = this.searchAutoComplete
            if (outlet.code && outlet.code.trim().length > 0) {
              this.result.outletAddress = outlet.address
              this.result.orderType = this.$const.DELIVERY
              this.result.locationName = outlet.address
              this.result.cityName = outlet.city_name
              this.result.villeageName = outlet.villeage_name
              this.result.st = outlet.st
              this.result.outletId = outlet.id
            } else {
              /**
               * handle process carryout
               * **/
              let geocoder = new google.maps.Geocoder()
              var vm = this
              geocoder.geocode({'address': this.searchAutoComplete}, function (results, status) {
                if (status === 'OK') {
                  var lat = results[0].geometry.location.lat()
                  var lng = results[0].geometry.location.lng()

                  if (!lng || !lat) {
                    vm.$modal.show(ModalDelivery, {
                      message: '',
                      methodSearch: vm.$const.DEFAULT_CONFIG_APP,
                      hideCollectionButton: true,
                      chooseAnotherDelivery: function () {
                        vm.openmapHaveAddress(lat, lng);
                      }
                    })
                    return false
                  }
                  let val = lng + ',' + lat
                  let data = {location: val, order_type: 'C', limit: 5}
                  vm.message = ''
                  vm.axios.apiOutlet.checkLocation(data, function (response) {
                    vm.searchLocation = false
                    vm.outletList = response.data.data.items
                    if (vm.outletList.length <= 0) {
                      vm.evenTrackingNotInDeliveryZone(vm.searchAutoComplete, lat, lng)
                      vm.$modal.show(ModalDelivery, {
                        message: '',
                        methodSearch: vm.$const.DEFAULT_CONFIG_APP,
                        hideCollectionButton: true,
                        chooseAnotherDelivery: function () {
                          vm.openmapHaveAddress(lat, lng);
                        }
                      })
                    } else {
                      vm.$modal.show(ModalCarryout, {methodSearch: vm.$const.DEFAULT_CONFIG_APP, outletList: vm.outletList})
                    }
                  }, function (error) {
                    vm.evenTrackingNotInDeliveryZone(vm.searchAutoComplete, lat, lng)
                    console.log(`error: ${error}`)
                    vm.$modal.show(ModalDelivery, {
                      message: '',
                      methodSearch: vm.$const.DEFAULT_CONFIG_APP,
                      hideCollectionButton: true,
                      chooseAnotherDelivery: function () {
                        vm.openmapHaveAddress(lat, lng);
                      }
                    })
                  })
                }
              })
            }
          } else {
            this.searchLocation = true
            this.searchAutoComplete = outlet.address
            this.getLatLog()

          }
        }
      },

        getLagLngByAddress () {
          let vm = this
          let geocoder = new google.maps.Geocoder()
          geocoder.geocode({'address': vm.searchAutoComplete}, function (results, status) {
            let lat = vm.lat ? vm.lat : results[0].geometry.location.lat()
            let long = vm.lng ? vm.lng : results[0].geometry.location.lng()
            vm.setDeliveryInfo(results[0])
            if (!vm.lng || !vm.lat) {
              vm.lng = long
              vm.lat = lat
            }
            if (status === 'OK') {
              if(vm.isMobile()) {
                  vm.$modal.show(ModalMapDelivery, {lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng(), address: vm.searchAutoComplete})
                }else{
                  vm.openmapHaveAddress(lat, long)
                  vm.handleCallbackMapDelivery(lat, long, false)
              }
            }
          })
        },
      _processValidOutlet (response) {
        let vm = this
        let lat = vm.lat
        let long = vm.lng
        let data = vm.$disposition.get(vm)
        // set data
        data.prefectureName = ''
        data.cityName = ''
        data.villeageName = ''
        data.st = ''
        data.lat = lat
        data.long = long
        data.postalCode = response.zip || vm.deliveryInfo.postalCode
        if (vm.orderType == vm.$const.DELIVERY) {
          data.locationName = vm.searchAutoComplete
          data.prefectureName = vm.deliveryInfo.state || ''
          data.cityName = vm.deliveryInfo.city || ''
          data.villeageName = vm.deliveryInfo.streetName || ''
          data.st = vm.deliveryInfo.streetNumber || ''
        } else {
          data.locationName = vm.result.locationName
        }
        data.minCart = response.min_cart
        data.outletAddress = response.address
        data.orderType = vm.result.orderType
        data.outletId = response.id
        data.outletName = response.name
        data.outletCode = response.code
        data.advanceOrder = vm.$disposition.getByKey(vm, 'advanceOrder', 0) || 0
        data.tier = response.tier
        data.takeaWayLess = vm.result.orderType === vm.$const.CARRYOUT ? (vm.result.takeaWayLess || 0) : 0
        data.customize = response.customize
        vm.$disposition.set(vm, data)
        vm.showHideMap(true)
        vm.addCustomEvent(vm.result.orderType, vm.result.orderType)
        vm.eventTrackingLocalisationSuccess(vm)
        if (data.takeaWayLess) {
          vm.setShowModalTakeAwayLess(vm.$const.SHOW_POPUP_QR)
        }
        if (vm.$route.query && vm.$route.query.callback) {
          vm.$router.push(vm.$route.query.callback)
        } else if (vm.routeLanding) {
          vm.redirectToMenuPage('promos', 'cheesybites')
        } else {
          vm.$root.$emit('onProcessChangeCategory')
        }
        vm.$root.$emit('showPopUpClosing')
      },
      /**
       * Checking outlet is available
       * */
      checkValidOutlet () {
        // check time outlet
        var vm = this
        var lat = vm.lat
        var long = vm.lng
        if(vm.orderType == vm.$const.DELIVERY && !vm.deliveryInfo.streetName) {
          return vm.$modal.show(ModalDelivery, {
            message: vm.$t('miss_streetName'),
            methodSearch: vm.$const.DEFAULT_CONFIG_APP,
            hideCollectionButton: false,
            chooseAnotherDelivery: function () {
              vm.openmapHaveAddress(lat, long);
            }
          })
        }

        let data = {
          order_type: this.orderType.charAt(0),
          order_time: this.convertDateTimeFromTimezoneToUTC(this.$disposition.getByKey(this, 'timezone', ''), this.$disposition.getByKey(this, 'collectionTimeText', '')),
          advance_order: this.$disposition.getByKey(this, 'advanceOrder', 0) || 0,
          outlet_id: this.result.outletId,
          address: this.searchAutoComplete ? this.searchAutoComplete : '',
          lat: lat,
          long: long
        }
        this.axios.apiOutlet.checkOutletAvailable(data,
          function (response) {
            response = response.data
            if (response.status) {
              response = response.data.item
              if (!response.warning_reason || !response.warning_reason.code) {
                vm._processValidOutlet(response)
              } else {
                vm.$modal.show(ModalWarning, {
                  title: "Warning",
                  outlet: response,
                  message: response.warning_reason.message,
                  closeCallBack: function (data) {
                    vm._processValidOutlet(data)
                  }
                })
              }
            } else if (response.message && response.message != '') {
              vm.$notify({
                type: 'warn',
                title: response.message
              })
            }
          },
          function (error) {
            let message = vm.getMessageFromGms(error)
            error = error.error
            let _lat = vm.lat || vm.locationCenter.lat
            let _lng = vm.lng || vm.locationCenter.lng
            vm.eventTrackingLocalisationError({id: 'error-localization', error: 'invalid-localisation'})
            vm.eventTrackingFailureLocalised()
            let _data = vm._.cloneDeep(vm.result)
            if (!_data.lat || !_data.lng) {
                _data.lat = _lat
                _data.long = _lng
            }
            /*HANDLE STORE STATUS ERROR*/
            if (vm.$const.MESSAGES_CODE.INCREASE_TIME.indexOf(error.code) > -1 ){
              vm.$modal.show(ModalActionError, {
                message: message,
                isProcessOrder: true,
              })
            }
            if (vm.$const.MESSAGES_CODE.STOP_DELIVERY_WITHOUT_TIME_RANGE_HAS_REASON.indexOf(error.code) > -1 ){
              vm.$modal.show(ModalActionError, {
                message: message,
                isRedirect: true,
                isChooseAnotherAddress: true,
                orderType: vm.orderType.charAt(0),
                outletDataLocalization: _data,
                outletId: vm.result.outletId,
              })
            }
            if (vm.$const.MESSAGES_CODE.STOP_DELIVERY_TOTAL.indexOf(error.code) > -1 ){
              vm.$modal.show(ModalActionError, {
                message: message,
                isRedirect: true,
                isShowAdvanceTime: true,
                isChooseAnotherAddress: true,
                orderType: vm.orderType.charAt(0),
                outletDataLocalization: _data,
                outletId: vm.result.outletId,
              })
            }
            if (vm.$const.MESSAGES_CODE.STOP_TOTAL_WITH_TIMEOUT_RANGE.indexOf(error.code) > -1 ){
              vm.$modal.show(ModalActionError, {
                message: message,
                isChooseAnotherAddress: true,
                isRedirect: true,
                orderType: vm.orderType.charAt(0),
                outletDataLocalization: _data,
                outletId: vm.result.outletId,
              })
            }
            if (vm.$const.MESSAGES_CODE.STOP_TOTAL_WITH_TIME_RANGE.indexOf(error.code) > -1 ){
              vm.$modal.show(ModalActionError, {
                message: message,
                isShowAdvanceTime: true,
                isChooseAnotherAddress: true,
                isRedirect: true,
                orderType: vm.orderType.charAt(0),
                outletDataLocalization: _data,
                outletId: vm.result.outletId,
              })
            }
            /*HANDLE STORE STATUS ERROR*/
            /*DEAD TRACKING*/
            if (vm.$const.LOCALIZATION_CODE.DELIVERY_DEADZONE.indexOf(error.code) > -1) {
              vm.eventTrackingDeliveryDeadZone('UnAvailable')
            } else if (vm.$const.LOCALIZATION_CODE.HUT_CLOSED.indexOf(error.code) > -1) {
              vm.eventTrackingHutClosed(data.outlet_id)
            } else if (vm.$const.LOCALIZATION_CODE.HUT_BOUNCING.indexOf(error.code) > -1){
              vm.evenTrackingHutIsBouncing(data.outlet_id)
            }

            if (error.code == vm.$const.LOCALIZATION_CODE.STORECLOSE || error.code == vm.$const.LOCALIZATION_CODE.CLOSESTORE) {
              vm.$modal.show(ConfirmStoreClose, {
                message: vm.$t('store_close'),
                outletId: vm.result.outletId,
                outletDataLocalization: vm.result,
                orderType: vm.orderType
              })
            }
            /*END*/

            // if (error.code == vm.$const.LOCALIZATION_CODE.UNAVALIABLE) {
            //   vm.$modal.show(ModalDelivery, {
            //     message: message,
            //     methodSearch: vm.$const.DEFAULT_CONFIG_APP,
            //     hideCollectionButton: false,
            //     chooseAnotherDelivery: function () {
            //       vm.openmapHaveAddress(_lat, _lng);
            //     }
            //   })
            // } else if (error.code == vm.$const.LOCALIZATION_CODE.STORECLOSE || error.code == vm.$const.LOCALIZATION_CODE.CLOSESTORE) {
            //   let _data = vm._.cloneDeep(vm.result)
            //   if (!_data.lat || !_data.lng) {
            //     _data.lat = _lat
            //     _data.long = _lng
            //   }
            //   vm.$modal.show(ConfirmStoreClose, {
            //     message: vm.$t('store_close'),
            //     outletId: vm.result.outletId,
            //     outletDataLocalization: _data,
            //     orderType: vm.orderType
            //   })
            // } else if (error.code === vm.$const.LOCALIZATION_CODE.HUT19) {
            //   vm.callEventBus(vm.$const.EVENT_BUS.SHOW_MODAL_DELIVERY, true)
            // } else if (error.code === vm.$const.LOCALIZATION_CODE.HUT20) {
            //   vm.callEventBus(vm.$const.EVENT_BUS.SHOW_MODAL_DELIVERY, true)
            // } else {
            //   let _data = vm._.cloneDeep(vm.result)
            //   if (!_data.lat || !_data.lng) {
            //     _data.lat = _lat
            //     _data.long = _lng
            //   }
            //   vm.$modal.show(ASAPPopup, {
            //     outletId: vm.result.outletId,
            //     orderType: vm.orderType.charAt(0),
            //     outletDataZip: _data,
            //     outletDataLocalization: {},
            //     gotoFindHut: ''
            //   })
            // }
          }
        )

      },
      /**
       * Search stores by zip code
       * */
      searchByZipCode () {
        var zipcode = ''
        this.errorPostalCode = ''
        this.mode = 'zip'

        this.addressList = []
        this.outletList = []
        zipcode = this.searchZipCode.replace('-', '').replace(/[\uff01-\uff5e]/g,
          function(ch) { return String.fromCharCode(ch.charCodeAt(0) - 0xfee0); }
        )
        if (!this.searchZipCode) {
          this.errorPostalCode = 'message_empty_postcode'
          return false
        }
        if (zipcode.length != 7) {
          this.errorPostalCode = 'message_invalid_postcode'
          return false
        }
        var vm = this
        this.loadingZip = true
        vm.message = ''
        this.$bus.$emit('loading', 'block')
        this.axios.apiOutlet.getOutletByAddressCode({zip_code: zipcode}, function (response) {
          vm.loadingZip = false
          if (response.data.data.items.length <= 0) {
            vm.message = vm.$t('localization.zipcode.stores_404')
          } else if (vm.routeLanding) {
            vm.redirectToMenuPage('promos', 'cheesybites')
          } else {
            vm.$router.push({'name': 'test-localization', params: {zip: zipcode}})
          }
          vm.$bus.$emit('loading', 'none')
        }, function (error) {
          console.log(`error: ${error}`)
          vm.loadingZip = false
          vm.message = vm.$t('localization.zipcode.stores_404')
          vm.$bus.$emit('loading', 'none')
        })
      },
      /**
       * Search stores by location
       * */
      searchByLocation (lat, lng) {
        this.locationCenter.lat = lat
        this.locationCenter.lng = lng
        this.mode = 'location'
        this.outletList = []
        this.addressList = []
        if (!lng || !lat) {
          return false
        }
        let val = lng + ',' + lat
        let data = {location: val, order_type: this.orderType.charAt(0), limit: 5}
        if (this.orderType.charAt(0) == 'D') {
          data = {location: val, disposition: this.orderType.charAt(0), limit: 5}
        }
        var vm = this
        vm.message = ''
        vm.axios.apiOutlet.checkLocation(data, function (response) {
          vm.searchLocation = false
          let res_data = response.data.data.items
          if (vm.orderType.charAt(0) == 'D') {
            if (res_data.length <= 0) {
              // call api for incase carryout
              vm.axios.apiOutlet.checkLocation({limit: data.limit, location: data.location, order_type: 'C'}, function (response) {
                let res1_data = response.data.data.items
                if (res1_data.length > 0) {
                  if(vm.orderType == vm.$const.DELIVERY)
                  {
                    vm.result.outletAddress = vm.outletList[0].address
                    vm.result.orderType = vm.orderType
                    vm.result.locationName = vm.outletList[0].address
                    vm.result.cityName = vm.outletList[0].city_name
                    vm.result.villeageName = vm.outletList[0].villeage_name
                    vm.result.st = vm.outletList[0].st
                    vm.result.outletId = vm.outletList[0].id
                    vm.checkValidOutlet()
                  }
                }else{
                  vm.$modal.show(ModalDelivery, {
                    message: '',
                    methodSearch: vm.$const.DEFAULT_CONFIG_APP,
                    hideCollectionButton: true,
                    chooseAnotherDelivery: function () {
                      vm.openmapHaveAddress(vm.locationCenter.lat, vm.locationCenter.lng);
                    }
                  })
                }
              }, function (error) {
                vm.searchLocation = false
                console.log(`error: ${error}`)
                vm.message = vm.$t('localization.stores_404') + ' ' + vm.$t(vm.orderType.toLowerCase()).toLowerCase()
              })
            } else {
              vm.beforeClickChosenOutlet(res_data[0])
            }
          } else {
            if (res_data.length <= 0) {
              vm.message = vm.$t('localization.stores_404') + ' ' + vm.$t(vm.orderType.toLowerCase()).toLowerCase()
            } else {
              vm.outletList = response.data.data.items
            }
          }
        }, function (error) {
          vm.searchLocation = false
          console.log(`error: ${error}`)
          vm.message = vm.$t('localization.stores_404') + ' ' + vm.$t(vm.orderType.toLowerCase()).toLowerCase()
        })
      },
      /**
       * Draw maps
       */
      drawMaps () {
        var vm = this
        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i].setMap(null)
        }
        this.markers = []
        if (this.locationCenter.lat != 0 && this.locationCenter.lng != 0) {
          let latlng = new google.maps.LatLng(this.locationCenter.lat, this.locationCenter.lng)
          let nMarket = new google.maps.Marker({
            position: latlng,
            map: this.map,
            draggable: false,
            icon: 'https://static.phdvasia.com/jp/icons/pin.png'
          })
          this.markers.push(nMarket)
        }
        let bounds = new google.maps.LatLngBounds()
        bounds.extend(new google.maps.LatLng(this.markers[0].getPosition().lat(), this.markers[0].getPosition().lng()))
        for (let i = 0; i < this.outletList.length; i++) {
          let latlng = new google.maps.LatLng(this.outletList[i].lat, this.outletList[i].long)
          let icon = {
            url: 'https://static.phdvasia.com/jp/icons/gray-logo.png',
            scaledSize: new google.maps.Size(40, 40)
          }
          let contentString = '<div id="content">' +
            '<div id="siteNotice">' +
            '</div>' +
            '<h1 id="firstHeading" class="firstHeading">' + this.outletList[i].name + '</h1>' +
            '<div id="bodyContent">' +
            '<p>' + this.outletList[i].address + '</p>' +
            '<p><button class="btn btn-success maps-infowindow t13 " style="padding: 8px 20px" onclick="infowindowClick(' + i + ')">' + this.$t('select') + '</button></p>' +
            '</div>' +
            '</div>'

          /*var infowindow = new google.maps.InfoWindow({
            content: contentString,
            maxWidth: 200
          })*/

          let marker = new google.maps.Marker({
            position: latlng,
            map: this.map,
            draggable: false,
            outletIndex: i,
            outlet: this.outletList[i],
            infowindow: new google.maps.InfoWindow({
              content: contentString
            }),
            title: this.outletList[i].address,
            icon: icon,
            hoverIcon: 'https://static.phdvasia.com/my/icons/red-logo.png',
            originIcon: 'https://static.phdvasia.com/jp/icons/gray-logo.png'
          })
          this.markers.push(marker)
          if (this.outletList[i].distance <= 10) {
            bounds.extend(new google.maps.LatLng(this.markers[i].getPosition().lat(), this.markers[i].getPosition().lng()))
          }
          marker.addListener('mouseover', function (e) {
            this.highlight = this.outletIndex
          })
          marker.addListener('click', function (e) {
            for (let i = 0; i < vm.markers.length; i++) {
              if (vm.markers[i].infowindow) {
                vm.markers[i].infowindow.close()
              }
            }
            vm.onChangeOutlet(this.outletIndex)
            this.infowindow.open(this.map, marker)
          })
          marker.addListener('mouseout', function (e) {
            this.highlight = null
          })
        }
        this.map.fitBounds(bounds)
      },
      loadScriptMap () {
        (function (d, s, id) {
          var js, fjs = d.getElementsByTagName(s)[0]
          if (d.getElementById(id)) return
          js = d.createElement(s); js.id = id
          js.async = true
          js.src = 'https://maps.googleapis.com/maps/api/js?key=' + keApi + '&libraries=places&language=' + language + '&region=' + region
          fjs.parentNode.insertBefore(js, fjs)
        }(document, 'script', 'google-maps-jssdk'))
      },
      /**
       * Trigger before open modal popup
       * */
      beforeOpen (event) {
        this.initMap()
        this.drawMaps()
        this.onChangeOutlet(0)
        document.body.classList.add('modal-open')
      },
      /**
       * Trigger before close modal popup
       * */
      beforeClose (event) {
        this.mapOpen = false
        document.body.classList.remove('modal-open')
      },
    },
    components: {
      MaskedInput,
      vSelect
    }
  }
</script>
<style scoped>
  .contain-outlet{
    max-height: 520px;
    overflow-y: auto;
  }
  #mylocation {
    padding: 6px;
    display: flex;
    align-items: center;
    min-height: 50px;
  }

  .disposition-title{
    font-size: 15px;
  }
  @media (min-width: 768px) {
    .disposition-title{
      font-size: 18px;
    }
  }

  #mapLocalization {
    height: 238px;
    width: 100%;
  }

  @media screen and (min-width: 48em){
    #mapLocalization {
      height: 455px;
    }
  }
  li.outlet-item:hover, .highlight{
    background: #3053691a;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/HomeLocalizationMapGoogleApi.vue